import { statoAnalisiDa } from '@/lib/myBoards/errori';
import type { AnalysisState, OriginView, PositionAnalysisView, PositionView } from '@/types/myBoards';

/**
 * Cosa la scheda sa della stima del bot (ADR-0191 §5 classe ii), in funzione di cio' che la scheda GIA' sa — pura, senza
 * React e senza rete: la esercita `tests/my-boards-analisi.test.ts`.
 *
 * L'ordine e' la regola:
 *  1. posizione di FINE GIOCO ⇒ `closed: terminal`, senza chiedere (il server direbbe 422);
 *  2. la partita d'origine com'e' ADESSO non e' ancora nota (la risposta di `GET /positions/:id` non e' arrivata) ⇒ `loading`:
 *     la lista porta un'origine che puo' essere vecchia (la partita puo' essere finita da quando si e' salvato);
 *  3. origine VIVA ⇒ `closed: source_live`, senza chiedere (il server direbbe 409);
 *  4. dati ⇒ `open`; un errore ⇒ chiusura (409/422 dal server: `position_live` solo da li') oppure «non disponibile ora»
 *     (503, rete: «Riprova» a mano); niente di tutto cio' ⇒ `loading`.
 */
export function statoDellaStima(i: {
  fase: PositionView['phase'];
  /** L'origine di `GET /positions/:id`, o `null` finche' non e' arrivata (o se e' fallita). */
  origine: Pick<OriginView, 'status'> | null;
  analisi: { data?: PositionAnalysisView; error?: unknown };
}): AnalysisState {
  if (i.fase === 'gameOver') return { kind: 'closed', reason: 'terminal' };
  if (i.origine === null) return { kind: 'loading' };
  if (i.origine.status === 'live') return { kind: 'closed', reason: 'source_live' };
  if (i.analisi.data) return { kind: 'open', analysis: i.analisi.data };
  if (i.analisi.error !== undefined) return statoAnalisiDa(i.analisi.error);
  return { kind: 'loading' };
}

/** Si chiede la stima solo quando si sa che puo' rispondere: partita d'origine finita (e nota ADESSO) e posizione non finale. */
export function sipuoChiedereLaStima(fase: PositionView['phase'], origine: Pick<OriginView, 'status'> | null): boolean {
  return fase !== 'gameOver' && origine !== null && origine.status === 'finished';
}
